import { Link } from 'gatsby-plugin-react-intl'

import styled, { css } from 'styled-components'

import check from '../../images/icons/check.svg'
import arrow from '../../images/icons/arrow-right.svg'

export const SimpleCardWrapper = styled.div`
  width: 100%;

  h3 {
    margin-bottom: 24px;
  }

  ${({ titleCheck }) =>
    titleCheck &&
    css`
      h3 {
        position: relative;

        font-size: 24px;
        line-height: 32px;

        ::before {
          content: url(${check});
          position: absolute;
          top: 2px;
          left: -30px;
        }
      }

      @media (max-width: 767px) {
        padding-left: 30px;
      }
    `}

  @media (max-width: 767px) {
    h3 {
      margin-bottom: 16px;
    }

    :last-child {
      margin-bottom: 0;
    }
  }
`

export const TitleCheck = styled.h3`
  position: relative;

  font-size: 24px;
  line-height: 32px;

  ::before {
    content: url(${check});
    position: absolute;
    top: 2px;
    left: -30px;
  }
`

export const SmallLink = styled(Link)`
  display: inline-block;
  font-size: 16px;
  line-height: 1.75;
  color: var(--orange);
  text-decoration: none;
  position: relative;
  border-bottom: 1px solid #fff;

  transition: all 0.2s;
  margin-top: 24px;
  padding: 3px 0;

  :hover {
    text-decoration: none;
    border-color: var(--orange);
  }

  ::after {
    content: url(${arrow});
    display: inline-block;
    position: absolute;
    top: 7px;
    margin-left: 4px;
    transition: all 0.2s;
  }

  @media (max-width: 768px) {
    margin-top: 16px;
  }

  @media (min-width: 768px) {
    :hover::after {
      transform: translateX(4px);
    }
  }
`

export const SimpleCardDarkWrapper = styled(SimpleCardWrapper)`
  color: #fff;

  @media (max-width: 767px) {
    margin-bottom: 64px;
  }
`
